module.exports = __webpack_public_path__ + "img/inside-wall.a7373b88.svg";